import dayjs from 'dayjs';

const rootConst = 'ALL_ORDERS';

export const GET_ORDER_LIST = `${rootConst}/GET_ORDER_LIST`;
export const GET_SELECTED_ORDER = `${rootConst}/GET_SELECTED_ORDER`;

export const CONFIRM_ORDER = `${rootConst}/CONFIRM_ORDER`;
export const FOR_PICKUP = `${rootConst}/FOR_PICKUP`;
export const COMPLETE_ORDER = `${rootConst}/COMPLETE_ORDER`;
export const CANCEL_ORDER = `${rootConst}/CANCEL_ORDER`;

export const BOOK_ORDER_RIDER = `${rootConst}/BOOK_ORDER_RIDER`;
export const BOOK_ORDER_COURIER = `${rootConst}/BOOK_ORDER_COURIER`;
export const CONFIRM_3RD_PARTY_ORDER = `${rootConst}/CONFIRM_3RD_PARTY_ORDER`;
export const REBOOK_DELIVERY_COURIER = `${rootConst}/REBOOK_DELIVERY_COURIER`;
export const DOWNLOAD_REPORT = `${rootConst}/DOWNLOAD_REPORT`;

export const OPTION_SORT_BY = [
  {
    label: 'ASCENDING',
    value: 'asc',
  },
  {
    label: 'DESCENDING',
    value: 'desc',
  },
];

export const OPTION_ORDER_BY = [
  {
    label: 'CREATED AT',
    value: 'created_at',
  },
  {
    label: 'ORDER NUMBER',
    value: 'order_number',
  },
];

export const OPTION_DELIVERY_TYPE = [
  {
    label: '3RD PARTY',
    value: '3RD_PARTY',
  },
  {
    label: 'IN HOUSE',
    value: 'IN_HOUSE',
  },
  {
    label: 'PICKUP',
    value: null,
  },
];

export const renderStatusBadge = {
  RECEIVED: {
    label: 'For Confirmation',
    type: 'warning',
  },
  WAITING_FOR_PAYMENT: {
    label: 'Waiting for Payment',
    type: 'warning',
  },
  PENDING: {
    label: 'For Preparation',
    type: 'info',
  },
  FOR_PICKUP: {
    label: 'For Pickup',
    type: 'orange',
  },
  IN_TRANSIT: {
    label: 'On Delivery',
    type: 'white',
  },
  DELIVERED: {
    label: 'Completed',
    type: 'success',
  },
  CANCELLED: {
    label: 'Cancelled',
    type: 'danger',
  },
  ALLOCATING: {
    label: 'Allocating',
    type: 'warning',
  },
  EXPIRED: {
    label: 'Expired',
    type: 'gray',
  },
  DEFAULT: {
    label: 'No Status',
    type: 'light',
  },
};

export const renderPaymentMethodBadge = {
  PAYMENT_GATEWAY: {
    label: 'Payment Gateway',
    type: 'light',
  },
  CASH_ON_DELIVERY: {
    label: 'Cash',
    type: 'warning',
  },
  DEFAULT: {
    label: 'No Status',
    type: 'white',
  },
};

export const OPTION_STATUS = [
  {
    label: 'FOR CONFIRMATION',
    value: 'RECEIVED',
  },
  {
    label: 'FOR PREPARING',
    value: 'PENDING',
  },
  {
    label: 'FOR PICKUP',
    value: 'FOR_PICKUP',
  },
  {
    label: 'IN TRANSIT',
    value: 'IN_TRANSIT',
  },
  {
    label: 'DELIVERED',
    value: 'DELIVERED',
  },
  {
    label: 'CANCELLED',
    value: 'CANCELLED',
  },
  {
    label: 'EXPIRED',
    value: 'EXPIRED',
  },
];

export const STATUS_OPT_1 = [
  {
    label: 'Waiting for Payment',
    value: 'WAITING_FOR_PAYMENT',
  },
  {
    label: 'Confirmation',
    value: 'RECEIVED',
  },
  {
    label: 'Preparing',
    value: 'PENDING',
  },
  {
    label: 'For Pickup',
    value: 'FOR_PICKUP',
  },
  {
    label: 'In Transit',
    value: 'IN_TRANSIT',
  },
  {
    label: 'Delivered',
    value: 'DELIVERED',
  },
  {
    label: 'Cancelled',
    value: 'CANCELLED',
  },
  {
    label: 'Expired',
    value: 'EXPIRED',
  },
  {
    label: 'All Orders',
    value: 'ALL_ORDERS',
  },
];

export const STATUS_OPT_2 = [
  {
    label: 'In Transit',
    value: 'IN_TRANSIT',
  },
  // {
  //   label: 'Delivered',
  //   value: 'DELIVERED',
  // },
  // {
  //   label: 'Cancelled',
  //   value: 'CANCELLED',
  // },
  // {
  //   label: 'Expired',
  //   value: 'EXPIRED',
  // },
];

export const THIRD_PARTY_OPTS = {
  55: '2GO Express',
  48: 'AirSpeed',
  19: 'Borzo (Formerly Mr.Speedy)',
  37: 'DingDong',
  38: 'GOGO XPRESS',
  39: 'GrabExpress',
  56: 'J&T Express',
  8: 'Lalamove',
  4: 'LBC',
  344: 'LBC',
  60: 'Mr Delivery PH',
  61: 'NinjaVan',
  342: 'NinjaVan',
  18: 'XDE',
  59: 'Zip Ph',
  341: '2GO Express',
  337: 'Airspeed',
  334: 'GOGO XPRESS',
  336: 'GrabExpress',
  3: 'XDE',
};

export const REMINDER_OPTS = [
  {
    label: '10 Minutes',
    value: 10,
  },
  {
    label: '15 Minutes',
    value: 15,
  },
  {
    label: '30 Minutes',
    value: 30,
  },
];

export const REMINDER_VIA_OPTS = [
  {
    label: 'SMS',
    value: 'SMS',
  },
  {
    label: 'In-app',
    value: 'APP',
  },
  {
    label: 'Both SMS and In-app',
    value: 'ALL',
  },
];

export const INIT_FORM = {
  is_customer_reminder: true,
  remind_every: null,
  reminder_via: REMINDER_VIA_OPTS?.[0],
  reminder_time: '',
  reminder_date: dayjs().format('YYYY-MM-DD'),
};
